import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { apiGetRequest } from "../../../Helpers/Requests";
import endpoints from "../../../Helpers/Endpoints";
import styles from "./styles";
import { useTranslation } from "react-i18next";

const DeleteDeactivatePricelistDialog = ({
  open,
  onClose,
  onConfirm,
  pricelist,
  actionLoader,
  dialogTitle,
  dialogHeading,
  dialogDescription,
  confirmBtnText,
  CommunityName,
}) => {
  const [activeOrders, setActiveOrders] = useState(0);

  const isArray = Array.isArray(pricelist);
  const pricelists = isArray ? pricelist : [pricelist];
  const multiple = pricelists.length > 1;
  const { t } = useTranslation(["delete-deactivate-pricelist", "categories"]);

  // default title
  const resolvedDialogTitle = dialogTitle || t("deactivate_pricelist");

  // default confirm button text
  const resolvedConfirmBtnText = confirmBtnText || t("deactivate_pricelist");

  const getTotalActiveOrders = async () => {
    try {
      let total = 0;
      for (const pl of pricelists) {
        const res = await apiGetRequest(
          endpoints.getActiveOrdersCount(pl.subcategory_id || pl.id)
        );
        if (res.status === 200) {
          total += res.data.active_orders_count;
        }
      }
      setActiveOrders(total);
    } catch (error) {
      console.error("Error fetching active orders:", error);
    }
  };

  useEffect(() => {
    if (open && pricelist) {
      getTotalActiveOrders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const names = pricelists
    ?.map(
      (p) =>
        t(p.name, { ns: "categories" }) ||
        t(p.subcategory_name, { ns: "categories" }) ||
        ""
    )
    ?.filter(Boolean)
    ?.join(", ");

  const {
    dialogPaper,
    header,
    title,
    closeButton,
    closeIcon,
    dialogContent,
    heading,
    description,
    activeOrdersStyles,
    dialogActions,
    cancelButton,
    confirmButton,
    progress,
  } = styles;

  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      maxWidth="556px"
      PaperProps={{
        sx: dialogPaper,
      }}
    >
      <Box sx={header}>
        <Typography sx={title}>{resolvedDialogTitle}</Typography>
        <IconButton sx={closeButton} onClick={onClose}>
          <CloseIcon sx={closeIcon} />
        </IconButton>
      </Box>

      <DialogContent sx={dialogContent}>
        <Typography sx={heading}>
          {dialogHeading ||
            (multiple
              ? `${t("are_you_sure_deactivate_multiple_part_1")} ${names}  ${t(
                  "are_you_sure_deactivate_multiple_part_2"
                )} ${CommunityName ?? t("community")}?`
              : `${t("are_you_sure_deactivate_single_part_1")} ${names} ${t(
                  "are_you_sure_deactivate_single_part_2"
                )} ${CommunityName ?? t("community")}?`)}
        </Typography>

        <Typography sx={description}>
          {dialogDescription ||
            (multiple
              ? `${t("service_stop_part_1")} ${CommunityName}. ${t(
                  "service_stop_part_2"
                )}`
              : `${t("services_stop_part_1")} ${CommunityName}. ${t(
                  "services_stop_part_2"
                )}`)}
        </Typography>

        <Typography sx={activeOrdersStyles}>
          {t("active_orders_part_1")} {activeOrders} {t("active_orders_part_2")}
        </Typography>
      </DialogContent>

      <DialogActions sx={dialogActions}>
        <Button sx={cancelButton} onClick={onClose} variant="contained">
          {t("delete_dialog.button_back_text")}
        </Button>
        <Button
          sx={confirmButton}
          onClick={onConfirm}
          variant="contained"
          disabled={actionLoader}
        >
          {resolvedConfirmBtnText}
          {actionLoader && (
            <CircularProgress
              size={20}
              color="rgba(255, 255, 255, 0.7)"
              sx={progress}
            />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDeactivatePricelistDialog;
